<template>
  <div id="Application">
    <router-view :outside="outside" :env_ssr="env_ssr"> </router-view>
  </div>
</template>

<script>
import VueRouter from 'vue-router';
import FaHome from './pages/find_agent/home';
import FaNew from './pages/find_agent/new';
import Policy from './pages/policy';

const routes = [
  {
    path: '/',
    component: FaHome,
    name: 'FaHome'
  },
  {
    path: '/find-agent',
    component: FaHome,
    name: 'FaHome'
  },
  {
    path: '/find-agent/step/:id',
    component: FaNew,
    name: 'FaNew',
    props: true
  },
  {
    path: '/privacy-policy',
    component: Policy,
    name: 'Policy'
  }];

const router = new VueRouter({
    mode: 'history',
    routes
  });

export default {
  name: 'Application',
  props: ['outside', 'env_ssr'],
  router
};

</script>